module.exports = __webpack_public_path__ + "img/self-logo.6861a678.png";